// extracted by mini-css-extract-plugin
export var cardTitle = "_il-1";
export var commentBubble = "_il-e";
export var commentForm = "_il-a";
export var commentInput = "_il-b";
export var commentLabel = "_il-d";
export var commentPrompt = "_il-9";
export var csatCard = "_il-0";
export var feedbackSection = "_il-7";
export var starDisabled = "_il-6";
export var starEmpty = "_il-5";
export var starFilled = "_il-4";
export var starWrapper = "_il-3";
export var starsContainer = "_il-2";
export var submittedComment = "_il-c";
export var thankYouText = "_il-8";